import React from 'react';
import { Button as UiButton } from '../ui/button';
import { cn } from '../ui/utils';

const Button = React.forwardRef(function Button(
  {
    children,
    buttonType = 'primary',
    className,
    isLoading = false,
    isDisabled = false,
    disabled,
    loadingText,
    ...restProps
  },
  ref
) {
  const variant = buttonType === 'secondary' ? 'outline' : 'default';
  const isButtonDisabled = Boolean(disabled || isDisabled || isLoading);

  return (
    <UiButton
      ref={ref}
      variant={variant}
      disabled={isButtonDisabled}
      className={cn('rounded-lg active:scale-[0.98] transition-transform', className)}
      {...restProps}
    >
      {isLoading ? loadingText || children : children}
    </UiButton>
  );
});

export { Button };
